import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { AuthService } from '../../states/auth/services/auth.service';
import { ROUTER_UTILS } from '../utils/router.utils';

export const noAuthGuard: CanMatchFn = () => {
  if (inject(AuthService).isLoggedIn) {
    return inject(Router).createUrlTree([ROUTER_UTILS.config.base.vehiclePark]);
  }

  return true;
};
